module.exports = __webpack_public_path__ + "img/3B6E10_E3F2C3_88AC2E_99CE51-256px.257bc084.png";